// RRレコメンド商品エリア、外部サイト流入版
import { html } from 'lit-html';
import { Env } from '../../../env';
import { isSoloare } from '../../../models/js_env';
import { RrAreaProfile } from '../../../models/rr_profile';
import { CarouselItemsFromExternalSite } from '../carousel_item/carousel_items_from_external_site';

export const RrAreaFromExternalSite = (rrAreaProfile: RrAreaProfile, isLogin: boolean) => {
  if (rrAreaProfile.rrAreaItems.length === 0)  return html``;

  if (isSoloare(Env.SITE_TYPE)) {
    // APIで行う大大・大カテコードのフィルタ処理によって表示する商品が存在しなくなったときに、
    // レコメンドエリアの枠が残ってしまうため、エレメントIDを埋め込んだdivのさらに上の階層のdivを予め非表示にし、
    // フィルタ処理後でも商品が存在する場合に、divのStyleを変更して表示させるようにする。
    if (document.getElementById(rrAreaProfile.placementName + '-parent')) document.getElementById(rrAreaProfile.placementName + '-parent')!!.style.display = 'block';
  }

  document.getElementById(rrAreaProfile.placementName)?.removeAttribute("style");
  const carouselId =  rrAreaProfile.placementName + "-carousel";
  return html`
  <div class="o-colBox -margin24 o-recommendArea_head">
    <div class="a-colitem">
      <div class="o-colBox -margin24">
        <div class="a-heading -typeh4">
          <h2 class="a-heading_text">${rrAreaProfile.rrAreaTitle}</h2>
        </div>
      </div>
    </div>
  </div>
  ${CarouselItemsFromExternalSite(rrAreaProfile.rrAreaItems, isLogin, carouselId, rrAreaProfile.perView)}
`;
}
